import React from 'react';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';

const PLACEHOLDER_CATEGORIES = [0, 1];
const PLACEHOLDER_SERVICES = [0, 1];
const PLACEHOLDER_ATTRIBUTES = [0];

/**
 * Renders the loading placeholder for the service scraper panel content,
 * mimicking categories, services and attribute rows.
 * @returns The placeholder layout for the scraper panel main section.
 */
const LoadingServiceScraperPanelContent = () => (
    <>
        {PLACEHOLDER_CATEGORIES.map(categoryIndex => (
            <div
                key={categoryIndex}
                className='service-scraper__category-section'
                aria-hidden='true'
            >
                <div className='service-scraper__category-header'>
                    <div className='flex flex-align-center gap-10'>
                        <LoadingPlaceholder
                            variant='rounded'
                            width={40}
                            height={40}
                        />
                        <LoadingPlaceholder
                            variant='text'
                            width={220}
                            height={32}
                        />
                    </div>
                    <LoadingPlaceholder
                        variant='circular'
                        width={32}
                        height={32}
                    />
                </div>
                <ul className='service-scraper__service-list'>
                    {PLACEHOLDER_SERVICES.map(serviceIndex => (
                        <li
                            key={serviceIndex}
                            className='service-scraper__service-type'
                        >
                            <div className='service-scraper__service-type__header'>
                                <div className='flex flex-align-center gap-10'>
                                    <LoadingPlaceholder
                                        variant='rounded'
                                        width={20}
                                        height={20}
                                    />
                                    <LoadingPlaceholder
                                        variant='text'
                                        width={180}
                                        height={32}
                                    />
                                </div>
                                <div className='flex flex-center'>
                                    <LoadingPlaceholder
                                        variant='rounded'
                                        width={70}
                                        height={24}
                                    />
                                </div>
                            </div>
                            <ul className='service-scraper__attribute-list'>
                                {PLACEHOLDER_ATTRIBUTES.map(attributeIndex => (
                                    <li
                                        key={attributeIndex}
                                        className='service-scraper__attribute'
                                    >
                                        <LoadingPlaceholder
                                            variant='rounded'
                                            width='100%'
                                            height={40}
                                        />
                                        <LoadingPlaceholder
                                            variant='rounded'
                                            width='100%'
                                            height={40}
                                        />
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </div>
        ))}
    </>
);

export default LoadingServiceScraperPanelContent;
